export enum WeekDays {
  MONDAY = 1,
  TUESDAY = 2,
  WEDNESDAY = 3,
  THURSDAY = 4,
  FRIDAY = 5,
  SATURDAY = 6,
  SUNDAY = 7,
}

export interface ShippableIsoWeekDays {
  canBeShippedOnIsoWeekday1: boolean
  canBeShippedOnIsoWeekday2: boolean
  canBeShippedOnIsoWeekday3: boolean
  canBeShippedOnIsoWeekday4: boolean
  canBeShippedOnIsoWeekday5: boolean
  canBeShippedOnIsoWeekday6: boolean
  canBeShippedOnIsoWeekday7: boolean
}
